var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeavyWeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.901,
    height: 50.173,
    fill: "#007cc2",
    viewBox: "0 0 48.901 50.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.928,13.379H30.716a8.159,8.159,0,1,0-12.531,0H6.973L0,50.173H48.9ZM24.451,2.94a5.22,5.22,0,1,1-5.22,5.22A5.226,5.226,0,0,1,24.451,2.94ZM21.372,37.677l-3.655-5.194-1.209,1.179v4.015h-2.4V25.928h2.4v4.658l4.665-4.658H24.51l-5.08,4.907,5.038,6.842Zm13.419-1.752-.183.146a8.583,8.583,0,0,1-2.3,1.335,6.949,6.949,0,0,1-2.466.454,6.628,6.628,0,0,1-3.111-.735,4.992,4.992,0,0,1-2.165-2.175,6.7,6.7,0,0,1-.716-3.1,7.183,7.183,0,0,1,.706-3.148,4.872,4.872,0,0,1,2.1-2.242,6.437,6.437,0,0,1,3.075-.719,6.148,6.148,0,0,1,2.294.413,4,4,0,0,1,1.681,1.2,5.178,5.178,0,0,1,.906,1.945l.119.463-2.207.606-.135-.457a3.528,3.528,0,0,0-.523-1.136,2.006,2.006,0,0,0-.833-.6,3.313,3.313,0,0,0-1.3-.245,3.916,3.916,0,0,0-1.5.26,2.7,2.7,0,0,0-.977.66,3.281,3.281,0,0,0-.593.928,5.186,5.186,0,0,0-.374,1.981,4.811,4.811,0,0,0,.443,2.19,2.676,2.676,0,0,0,1.228,1.227,4.01,4.01,0,0,0,1.8.42,4.319,4.319,0,0,0,1.626-.321,4.9,4.9,0,0,0,1.034-.543V33.45H29.254V31.215l5.537-.009Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeavyWeightIcon);
export default __webpack_public_path__ + "static/media/heavyWeightIcon.587388c8a600749466370b1fa7f9b41f.svg";
export { ForwardRef as ReactComponent };